import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import href from '#utilities/js/ea/href.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { root } = defaults
    const fragment = button.closest('[data-fragment="contracts.chat.mains.meet"]')
    const scopeNode = one('span[data-scope-json]', fragment)
    const { thread_id, chat_url } = scope(scopeNode)
    let url

    if (root.getAttribute('data-skin') === 'web2') {
      url = href('auth/main', { url: chat_url })
    } else {
      url = href('chat/threads', { thread: thread_id })
    }

    globals.ea_link_direct(url, '_blank', null)
  }
})

export default button => {
  onClick.listen(button)
}
